<script>
  import { Router, Route } from "svelte-routing";

  import Admin from "./routes/Admin.svelte";
  import Adopt from "./routes/Adopt.svelte";
  import Adoptable from "./routes/Adoptable.svelte";
  import AdoptionRequests from "./routes/AdoptionRequests.svelte";
  import AdoptionRequest from "./routes/AdoptionRequest.svelte";
  import EditAdoptable from "./routes/EditAdoptable.svelte";
  import Home from "./routes/Home.svelte";
  import NewAdoptable from "./routes/NewAdoptable.svelte";
  import Survey from "./routes/Survey.svelte";
  import Welcome from "./routes/Welcome.svelte";

  export let url = "";
</script>

<Router url="{url}">
  <!-- private routes -->
  <Route path="/_admin" component={Admin} />
  <Route path="/_editadoptable/:kind/:id" let:params>
    <EditAdoptable id={params.id} kind={params.kind} />
  </Route>
  <Route path="/_adoptionrequests" component={AdoptionRequests} />
  <Route path="/_adoptionrequest/:id" let:params>
    <AdoptionRequest id={params.id} />
  </Route>
  <Route path="/_newadoptable" component={NewAdoptable} />
  <!-- public routes -->
  <Route path="/" component={Welcome} />
  <Route path="/adoptables" component={Home} />
  <Route path="/survey" component={Survey} />
  <Route path="/adopt/:kind/:id" let:params>
    <Adopt id={params.id} kind={params.kind} />
  </Route>
  <Route path="/adoptable/:kind/:id" let:params>
    <Adoptable id={params.id} kind={params.kind} />
  </Route>
</Router>

<link rel="stylesheet" href="https://unpkg.com/papercss@1.8.2/dist/paper.min.css">